module.exports = __webpack_public_path__ + "static/img/ic_serviceflow_c.4e9804f7.png";